export default __webpack_public_path__ + "static/media/deleteicon.1019664b.svg";